import React, { useState } from 'react'
import { Box, Button, Card, Checkbox, FormControlLabel, FormGroup, InputLabel, TextField } from '@mui/material'
import { Ingredient } from 'src/types/types';
import ReactQuill from 'react-quill';
import { updateIngredient as updateStoreIngredient, useAppDispatch } from 'src/store';
import 'react-quill/dist/quill.snow.css';
import useApi from '../../hooks/useApi'

export type UpdateIngredientFormProps = {
    ingredient: Ingredient
}


function getFormValues(event: any) {
    const data = new FormData(event.currentTarget);
    return Object.fromEntries(data.entries());
}


function useSubmit(fn: any) {
    return (event: any) => {
        event.preventDefault();
        const values = getFormValues(event);
        return fn(values);
    };
}

const UpdateIngredientForm = (props: UpdateIngredientFormProps) => {

    const { ingredient } = props
    const dispatch = useAppDispatch()
    const api = useApi()

    const [autoPlay, setAutoPlay] = useState(ingredient.autoPlay)
    const [availability, setAvailability] = useState(ingredient.available)
    const [description, setDescription] = useState(ingredient.description)

    const handleSubmit = useSubmit((values: any) => {
        var updatedIngredient = Object.assign({}, ingredient, {
            afterMediaSrc: values.afterMediaSrc,
            autoPlay: autoPlay,
            available: availability,
            beforeMediaSrc: values.beforeMediaSrc,
            description: description,
            name: values.name,
        })
        const submitForm = async () => {
            if (!api) { throw 'Api not loaded' }
            updatedIngredient = await api.updateIngredient(updatedIngredient)
            if (updatedIngredient) {
                dispatch(updateStoreIngredient(updatedIngredient))
            }
        }
        submitForm()

    });

    const handleAutoplayChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setAutoPlay(e.target.checked)
    }

    return (
        <Box>
            <Card sx={{ padding: 3 }} >

                <form onSubmit={handleSubmit}>
                    <TextField fullWidth name="name" label="Name" variant="standard" defaultValue={ingredient.name} />
                    <br />
                    <br />
                    <InputLabel shrink>Description</InputLabel>
                    <ReactQuill theme="snow" value={description} onChange={setDescription} />
                    <FormControlLabel
                        control={
                            <Checkbox
                                defaultChecked={ingredient.available}
                                name="availability"
                                onChange={(e) => { setAvailability(e.target.checked) }}
                            />}
                        label="Available?"
                    />
                    <br />   
                    <FormGroup>
                        <FormControlLabel name="autoPlay" control={<Checkbox defaultChecked={ingredient.autoPlay} onChange={handleAutoplayChange} />} label="AutoPlay?" />
                    </FormGroup>
                    <br />
                    <TextField fullWidth name="beforeMediaSrc" label="Before Example Url" variant="standard" defaultValue={ingredient.beforeMediaSrc} />
                    <br />
                    <br />
                    <TextField fullWidth name="afterMediaSrc" label="After Example Url" variant="standard" defaultValue={ingredient.afterMediaSrc} />
                    <br />
                    <br />
                    <Button variant="contained" type="submit">Update</Button>
                </form>

            </Card>

        </Box >
    )
}

export default UpdateIngredientForm